import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import typography from '../../styling/mixins/typography';

const dekSmall = styled.p`
  ${typography.paragraphSmall};
  width: 100%;
`;

dekSmall.propTypes = {
  children: PropTypes.any.isRequired,
};

dekSmall.displayName = 'DekSmall';

export const DekSmall = dekSmall;

const Dek = styled.p`
  ${typography.paragraph};
  width: 100%;
`;

Dek.propTypes = {
  children: PropTypes.any.isRequired,
};

Dek.displayName = 'Dek';

export default Dek;

let dekLarge = styled.p`
  ${typography.paragraphLarge};
  width: 100%;
`;

dekLarge.propTypes = {
  children: PropTypes.any.isRequired,
};

dekLarge.displayName = 'DekLarge';

export const DekLarge = dekLarge;
